"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScaleTransition = ScaleTransition;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _useTransition = require("../_utils/hooks/useTransition");
var _BaseTransition = require("./BaseTransition");
var _excluded = ["from", "to", "timeout", "origin"];
function ScaleTransition(_ref) {
  var from = _ref.from,
    to = _ref.to,
    timeout = _ref.timeout,
    origin = _ref.origin,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var enterTimeout = 0;
  var exitTimeout = 0;
  if (typeof timeout === 'number') {
    enterTimeout = timeout;
    exitTimeout = timeout;
  } else if (timeout && (0, _typeof2.default)(timeout) === 'object') {
    if (timeout.enter) {
      enterTimeout = timeout.enter;
    } else {
      enterTimeout = 0;
    }
    if (timeout.exit) {
      exitTimeout = timeout.exit;
    } else {
      exitTimeout = 0;
    }
  }
  return /*#__PURE__*/_react.default.createElement(_BaseTransition.BaseTransition, (0, _extends2.default)({}, (0, _useTransition.useScale)(from, to, enterTimeout, exitTimeout, origin), rest));
}